import * as React from "react";
import { InsightPageProvider } from "@radarly/core/insight-pages/context";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useInsightPage } from "../insight-pages/use-cases";
import { useCurrentUser } from "../user/use-cases";
import { useInitIntercom } from "./use-cases/useInitIntercom";
import { useInitTrackers } from "./use-cases/useInitTrackers";

export default function InsightPageConnectedPage({
  id,
  children,
}: {
  id: string;
  children: React.ReactNode;
}) {
  const project = useCurrentProject();
  const user = useCurrentUser();

  useInitTrackers(user, project);
  useInitIntercom(user);

  const { page } = useInsightPage(project.id, id);

  return (
    <InsightPageProvider insightPage={page}>{children}</InsightPageProvider>
  );
}
